import React, { useContext } from 'react';
import { LogoLoading } from 'ensightful-koala-ui';

import { CreateChannelDialog, EditChannelDialog, ManageMembersDialog } from 'components/organisms/Chat';
import { useUser2 } from 'contexts/user2';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/Chat/PageProvider';
import Mobile from 'pages/Chat/InstructorChat/mobile';
import Tablet from 'pages/Chat/InstructorChat/tablet';
import Desktop from 'pages/Chat/InstructorChat/desktop';
import { AlertDialog } from 'shell/components';

const PageLayout = () => {
    const { isLoading } = useUser2();
    const { device } = useViewport();
    const {
        activeGroupId,
        channels,
        setChannels,
        activeChatId,
        setActiveChatId,
        createChannelDialog,
        setCreateChannelDialog,
        editChannelDialog,
        setEditChannelDialog,
        manageMembersDialog,
        setManageMembersDialog,
        alertDialog,
    } = useContext(PageContext);

    const renderResponsiveLayouts = (device) => {
        return {
            mobile: <Mobile />,
            tablet: <Tablet />,
            desktop: <Desktop />,
        }[device];
    };

    return isLoading ? (
        <LogoLoading />
    ) : (
        <>
            {renderResponsiveLayouts(device)}
            <CreateChannelDialog
                activeGroupId={activeGroupId}
                setChannels={setChannels}
                setActiveChatId={setActiveChatId}
                createChannelDialog={createChannelDialog}
                setCreateChannelDialog={setCreateChannelDialog}
            />
            <EditChannelDialog
                activeGroupId={activeGroupId}
                channels={channels}
                setChannels={setChannels}
                activeChatId={activeChatId}
                editChannelDialog={editChannelDialog}
                setEditChannelDialog={setEditChannelDialog}
            />
            <ManageMembersDialog
                activeGroupId={activeGroupId}
                channels={channels}
                setChannels={setChannels}
                activeChatId={activeChatId}
                manageMembersDialog={manageMembersDialog}
                setManageMembersDialog={setManageMembersDialog}
            />
            <AlertDialog {...alertDialog} />
        </>
    );
};

export default PageLayout;
